import script from "./TGModal.vue?vue&type=script&setup=true&lang=js"
export * from "./TGModal.vue?vue&type=script&setup=true&lang=js"

import "./TGModal.vue?vue&type=style&index=0&id=27260086&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27260086"]])

export default __exports__